import {
  fetchTicketsByEntity,
  fetchTicketsSummary,
  fetchAllTickets,
  fetchTicketById,
  fetchTicketUpdatesAndComments,
  fetchTicketFiles,
  loadMoreTicketsByEntity,
  clearTickets,
} from '../routines/ticketRoutines';

const initialState = {
  tickets: [],
  allTickets: [],
  ticketDetails: {},
  ticketUpdatesAndComments: [],
  ticketFiles: {
    data: [],
    loading: false,
    error: null,
  },
  ticketActivityFiles: [],
  allTicketLoading: false,
  allTicketError: false,
  ticketFetchLoading: false,
  ticketFetchError: false,
  allTicketActivityLoading: false,
  allTicketActivityError: false,
  currentPayload: null, // the payload used for the current result set
  errorMsg: null,
  paginationData: {},
  paginationDataForActivityFeed: {},
  ticketSummary: {},
  ticketSummaryLoading: false,
  ticketSummaryError: null,
  loadingMore: false,
};

const ticketReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchTicketsByEntity.TRIGGER:
      return {
        ...state,
        ticketFetchLoading: true,
        ticketFetchError: false,
      };

    case loadMoreTicketsByEntity.TRIGGER:
      return {
        ...state,
        loadingMore: true,
        ticketFetchError: false,
      };
    case fetchTicketsSummary.TRIGGER:
      return {
        ...state,
        ticketSummaryLoading: true,
        ticketSummaryError: false,
      };
    case fetchAllTickets.TRIGGER:
      return {
        ...state,
        allTicketLoading: true,
        allTicketError: false,
      };
    case fetchTicketById.TRIGGER:
      return {
        ...state,
        ticketFetchLoading: true,
        ticketFetchError: false,
      };
    case fetchTicketUpdatesAndComments.TRIGGER:
      return {
        ...state,
        allTicketActivityLoading: true,
        allTicketActivityError: false,
      };
    case fetchTicketFiles.TRIGGER:
      return {
        ...state,
        ticketFiles: { ...state.ticketFiles, loading: true },
      };
    case fetchTicketsByEntity.SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        ticketFetchLoading: false,
        tickets: data?.tickets || [],
        paginationDataForActivityFeed: {
          page: data?.page,
          pageSize: data?.pageSize,
          totalItems: data?.totalItemCount,
        },
      };
    }
    case loadMoreTicketsByEntity.SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        loadingMore: false,
        tickets: [...state.tickets, ...(data?.tickets ?? [])],
        paginationDataForActivityFeed: {
          page: data?.page,
          pageSize: data?.pageSize,
          totalItems: data?.totalItemCount,
        },
      };
    }
    case fetchTicketsSummary.SUCCESS:
      return {
        ...state,
        ticketSummaryLoading: false,
        ticketSummary: action.payload && action.payload.data,
      };
    case fetchAllTickets.SUCCESS: {
      const { response, currentPayload } = action.payload;
      return {
        ...state,
        allTicketLoading: false,
        allTicketsSuccess: true,
        allTickets: response.tickets || [],
        paginationData: {
          page: response.page,
          pageSize: response.pageSize,
          totalItems: response.totalItemCount,
        },
        currentPayload,
      };
    }
    case fetchTicketById.SUCCESS: {
      const update = {
        ...state,
        ticketFetchLoading: false,
        ticketDetails: action.payload && action.payload.data,
      };
      update.ticketFiles = {
        ...state.ticketFiles,
        data: [],
      };
      return update;
    }
    case fetchTicketUpdatesAndComments.SUCCESS: {
      return {
        ...state,
        allTicketActivityLoading: false,
        ticketUpdatesAndComments: action.payload && action.payload.data,
      };
    }
    case fetchTicketFiles.SUCCESS: {
      return {
        ...state,
        ticketFiles: {
          ...state.ticketFiles,
          data: [...state.ticketFiles.data, ...(action?.payload?.data || [])],
          loading: false,
          error: null,
        },
      };
    }
    case loadMoreTicketsByEntity.FAILURE: {
      return {
        ...state,
        loadingMore: false,
        ticketFetchError: true,
      };
    }
    case fetchTicketsByEntity.FAILURE:
      return {
        ...state,
        ticketFetchLoading: false,
        ticketFetchError: true,
      };
    case fetchTicketsSummary.FAILURE:
      return {
        ...state,
        ticketSummaryLoading: false,
        ticketSummaryError: true,
      };
    case fetchAllTickets.FAILURE:
      return {
        ...state,
        allTicketLoading: false,
        allTicketError: true,
      };
    case fetchTicketById.FAILURE:
      return {
        ...state,
        ticketFetchLoading: false,
        ticketFetchError: true,
      };
    case fetchTicketUpdatesAndComments.FAILURE:
      return {
        ...state,
        allTicketActivityLoading: false,
        allTicketActivityError: true,
      };
    case fetchTicketFiles.FAILURE:
      return {
        ...state,
        ticketFiles: {
          ...state.ticketFiles,
          loading: false,
        },
      };
    case clearTickets.TRIGGER:
      return {
        ...state,
        ticketFetchLoading: false,
        tickets: [],
        paginationDataForActivityFeed: {},
      };
    default:
      return state;
  }
};

export default ticketReducer;
